export default __webpack_public_path__ + "static/media/StoryRover.1630f0f4.png";